<ng-template #profileChangePasswordModal>
  <div
    class="modal"
    id="changeMasterPwdPopup"
  >
    <div class="modal-dialog modal-dialog-centered" role="document" id="changeMasterPwdDialog">
      <div class="modal-content" id="changeMasterPwdPopupModalContent">
        <div class="close" data-dismiss="modal" (click)="dismiss()" id="changeMasterPwdCloseBtn">
          <img class="popup_close_button" alt="close" />
        </div>
        <div class="modal-body" id="changeMasterPwdModalBody">
          <div class="heading" id="changeMasterPwdHeading">
            <span i18n="@@change-password.change-passwd-main-heading">Change {{type}} Password</span>
          </div>
          <form [formGroup]="form">
            <div class="form-group" id="changeMasterPwdFrmGrp">
              <label>
                <span i18n="@@change-password.new-password-heading">New {{type}} Password</span>
              </label>
              <input class="form-control pwdInput" [type]="showHideEyeIcon ? 'text' : 'password'"
                [placeholder]="enterPrimaryPassPlaceholderText" formControlName="password" id="password" [ngClass]="{ 'has-error': formCont.password.touched && 
                              formCont.password.invalid || formCont.confirm_password.errors?.confirmedValidator}" maxlength="30" />
              <!-- <i class="pw_icon"></i> -->
              <!-- <i class="err_icon"></i> -->
              <em class="error_icon" 
              *ngIf="formCont.password.touched && formCont.password.invalid && formCont.password.errors 
              || formCont.confirm_password.errors?.confirmedValidator"
              ></em>
              <em *ngIf="formCont.password.value"   
                [ngClass]="{
                  'eye-slash': showHideEyeIcon,
                  'eye': !showHideEyeIcon
                }"
                (click)="toggleshowHideEyeIcon('showHideEyeIcon')"
              ></em>
              <div *ngIf="formCont.password.touched && formCont.password.invalid" class="formfield_err_msg" id="changeMasterPwdErrMsg">
                <div *ngIf="formCont.password.errors.required" id="changeMasterPwdErr">
                  <span i18n="@@change-password.passwd-required-msg">Password is required</span>
                </div>
                <div *ngIf="formCont.password.errors.minlength" id="changeMasterPwdErrMinLen">
                  <span i18n="@@change-password.passwd-minimum-character-msg">Password must contain at least 5 characters</span>
                  </div>
              </div>
              <div class="formfield_err_msg" id="changeMasterPwdDoesntMatchMsg"
              *ngIf="!formCont.password.errors &&
              formCont.confirm_password.errors?.confirmedValidator">
              <span i18n="@@change-password.passwd-doesnt-match-msg">Password doesn’t match</span>
            </div>
            </div>
            <div class="form-group" id="changeMasterPwdPassText">
              <label>{{confirmPrimaryPassText}}</label>
              <input class="form-control pwdInput" [type]="showHideEyeIcon2 ? 'text' : 'password'"
                [placeholder]="confirmPrimaryPassText" formControlName="confirm_password" id="confirm_password" [ngClass]="{ 
                                'has-error': formCont.confirm_password.touched && 
                                formCont.confirm_password.invalid
                              }" maxlength="30" />
              <em class="error_icon" 
                *ngIf="formCont.confirm_password.touched && 
                formCont.confirm_password.invalid && 
                formCont.confirm_password.errors"
              ></em>
              <em *ngIf="formCont.confirm_password.value"   
                [ngClass]="{
                  'eye-slash': showHideEyeIcon2,
                  'eye': !showHideEyeIcon2
                }"
                (click)="toggleshowHideEyeIcon('showHideEyeIcon2')"
              ></em>
              <div *ngIf="formCont.confirm_password.touched && formCont.confirm_password.invalid" class="formfield_err_msg" id="changeMasterPwdErrMsg">
                <div *ngIf="formCont.confirm_password.errors.required">
                  <span i18n="@@change-password.passwd-required-msg">Password is required</span>
                </div>
                <div *ngIf="formCont.confirm_password.errors.minlength" id="changeMasterPwdErrMinLen5">
                  <span i18n="@@change-password.passwd-minimum-character-msg">
                    Password must contain at least 5 characters
                  </span>
                </div>
                <div *ngIf="
                formCont.confirm_password.errors?.confirmedValidator" id="pwdDoesntMatchMsgDiv">
                <span i18n="@@change-password.passwd-doesnt-match-msg">Password doesn’t match</span>
              </div>
            </div>        
            </div>
          </form>
        </div>
        <div class="modal-footer" id="changeMasterModalFooter">
          <button class="btn btn-outline-primary btn-lg" (click)="dismiss()">
            <span i18n="@@change-password.cancel-btn">Cancel</span>
          </button>
          <button class="btn btn-primary btn-lg" (click)="submit(type)" [disabled]="!form.valid" >
            <span i18n="@@change-password.change-passwd-btn">Change Password</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>